const CHANNEL_PALETTE = ['#C85AD6', '#039BE5', '#05E08E', '#FF9432'];

const OVERFLOW_RED = '#EF252A';
const TRACK_BG = '#F8F8F8';

const GRADIENT_ALPHA_DEFAULT = '66';
const GRADIENT_ALPHA_HOVER_START = '4D';
const GRADIENT_ALPHA_HOVER_END = 'B3';

const withAlpha = (hexColor, alphaHex) => `${hexColor}${alphaHex}`;

/**
 * Returns the per-channel ProgressBar theme fragment merged on top of the lib's default theme.
 *
 * Performances shows one ProgressBar per sales channel with a distinct color and a red state
 * when the cost/price ratio exceeds 100%. The shared ProgressBar wrapper from
 * `@commons/utils/styledLibraryComponents` only supports `variation="positive" | "negative"`
 * with a single theme — that pattern cannot drive per-channel colors. ChannelBar therefore
 * imports `ProgressBar` from `deepsight-react-components` directly: the app wrapper always
 * passes `theme={getTheme()}` and would drop any per-channel override.
 */
export const getChannelProgressTheme = (channelIndex, isOverflow) => {
  const baseColor = isOverflow
    ? OVERFLOW_RED
    : CHANNEL_PALETTE[channelIndex % CHANNEL_PALETTE.length];

  return {
    progressBar: {
      color: {
        start: {
          positive: TRACK_BG,
          negative: TRACK_BG,
        },
        end: {
          positive: withAlpha(baseColor, GRADIENT_ALPHA_DEFAULT),
          negative: withAlpha(baseColor, GRADIENT_ALPHA_DEFAULT),
        },
      },
      hover: {
        start: {
          positive: withAlpha(baseColor, GRADIENT_ALPHA_HOVER_START),
          negative: withAlpha(baseColor, GRADIENT_ALPHA_HOVER_START),
        },
        end: {
          positive: withAlpha(baseColor, GRADIENT_ALPHA_HOVER_END),
          negative: withAlpha(baseColor, GRADIENT_ALPHA_HOVER_END),
        },
      },
      dot: {
        color: {
          positive: baseColor,
          negative: baseColor,
          neutral: TRACK_BG,
        },
      },
    },
  };
};

export default getChannelProgressTheme;
